// components/match/MatchStatus.js
import React from "react";
import MatchDateTime from "../../common/MatchDateTime";
import { DateUtility } from "../../../utils/dateUtility";
import { GetTennisMatchStatus } from "../../../utils/generalLiveCenter";

const MatchStatus = ({ match, sport, live, statusText, statusClass, liveStatusText, dictionary, difference, displayDate }) => {
    return (
        <div
            className={`match_info_top ${!match?.odds ? "extra" : ""}`}
        >
            {displayDate && (
                <span className="date">
                    {DateUtility?.FormatDateh2h(
                        new Date(match?.dt || match?.d)
                    )}
                </span>
            )}
            {statusText && (
                <span className={statusClass}>
                    {dictionary?.[
                        statusText.replaceAll(" ", "").toLowerCase()
                    ] || statusText}
                </span>
            )}

            {liveStatusText && sport !== "tennis" && sport !== "basketball" && sport !== "icehockey" ? (
                <span className={live ? "status red" : "info"}>
                    {(sport === "basketball" || sport === "icehockey") && live && (
                        <span>{match?.cp}&nbsp;-&nbsp;</span>
                    )}
                    {dictionary?.[liveStatusText.replaceAll(" ", "").toLowerCase()] ||
                        liveStatusText}
                </span>
            ) : null}

            {sport === "tennis" && live && (
                <span className={live ? "status red" : "info"}>
                    {GetTennisMatchStatus(match?.st, match?.cp, match)} -{" "}
                    {dictionary?.[
                        liveStatusText.replaceAll(" ", "").toLowerCase()
                    ] || liveStatusText}
                </span>
            )}
            {/* {sport === "basketball" && live && (
          <span className="time">{match?.cp}</span>
        )} */}

            {sport === "cricket" && live && (
                <>
                    <span className="time">{match?.st}</span>
                    <span className="time">
                        {DateUtility?.FormatDateh2h(new Date(match?.ldt))}
                    </span>
                </>
            )}

            {sport === "cricket" &&
                (match?.bs === "Delayed" || match?.bs === "Stumps") && (
                    <>
                        <span className="status">{match?.bs}</span>
                    </>
                )}
            {sport === "cricket" && match?.st === "Abandoned" && (
                <>
                    <span className="status">{match?.bs}</span>
                    {/* <span className="time">{match?.st}</span> */}
                </>
            )}

            {!live && match?.st !== "Finished" && match?.st !== "Finished AET" && match?.st !== "Finished AP" && (
                <MatchDateTime
                    match={match}
                    sport={sport}
                    difference={difference}
                />
            )}
        </div>

    );
};

export default MatchStatus;
